module.exports = __webpack_public_path__ + "static/media/long-arrow-right-black.ace08695.svg";